import React from "react";
import { useTranslation } from "react-i18next";
const Loader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen w-full flex items-center justify-center relative py-12 px-4 overflow-x-hidden bg-brand-dark text-white">
      {/* Background Image */}
      <img
        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/e756a2f559-0b9a20970f67ec494033.png"
        alt="Luxury tropical resort"
        className="bg-destination animate-blur-reveal object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-dark/80 via-brand-dark/60 to-brand-dark/90 z-0"></div>
      {/* Main Content */}
      <main className="relative z-10 flex flex-col items-center justify-center w-full max-w-4xl mx-auto text-center">
        {/* Logo Glow */}
        <div className="logo-glow animate-pulse"></div>

        {/* Logo */}
        <div className="mb-8 animate-slide-up">
          <h1 className="font-heading text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-bold tracking-wider text-white mb-2">
            <span className="text-brand-pink">
              <span className="text-white">GET2</span>VACATIONS
            </span>
          </h1>

          <p className="text-gray-400 text-xs sm:text-sm md:text-base tracking-[0.2em] sm:tracking-[0.3em] uppercase font-light mt-4 px-4 animate-fade-in">
            {t("SMART ROUTES, BETTER DESTINATIONS")}
          </p>
        </div>

        {/* Progress Bar */}
        <div className="mt-8 sm:mt-16 animate-fade-in w-full max-w-xs mx-auto">
          <div className="progress-bar-container mb-4 w-48 sm:w-64">
            <div className="progress-bar"></div>
          </div>

          <p className="text-[10px] sm:text-xs text-gray-500 mt-6 uppercase tracking-widest font-light">
            {t("Preparing your journey")}
          </p>
        </div>
      </main>

      {/* Corner accents */}
      <div className="absolute top-8 left-8 w-16 h-16 border-t border-l border-white/10 z-10 hidden md:block"></div>

      <div className="absolute bottom-8 right-8 w-16 h-16 border-b border-r border-white/10 z-10 hidden md:block"></div>
    </div>
  );
};

export default Loader;
